import { getCompany, getCompanyBonusPointsConfig, getCompanyPopups } from '@/api/company'

const company = {
  namespaced: true,
  state: () => ({
    status: {
      company: {
        initialized: false,
        refreshing: false,
        error: false,
      },
      popups: {
        initialized: false,
        refreshing: false,
        error: false,
      },
      bonusPoints: {
        initialized: false,
        refreshing: false,
        error: false,
      }
    },
    name: '',
    loginCopyHtml: '',
    customLoginId: '',
    logoUrl: '',
    bannerUrl: '',
    homepageMessageHtml: '',
    blogHeading: '',
    blogUrl: '',
    programNameHtml: '',
    programDescriptionHtml: '',
    requireCredentialsForCheckout: true,
    allowTaxPaymentWithPoints: false,
    grossUpTaxes: false,
    popups: [],
    bonusPointsIsEnabled: false,
    bonusPointsMenuItem: '',
    bonusPointsPageTitle: '',
    bonusPointsPageMessage: '',
    bonusPointsPointsAlias: '',
    bonusPointsIconClass: '',
    stripeCustomerId: null,
    ratio: 0,
    unallocDeposit: 0
  }),
  getters: {
    getCompanyName(state) {
      return state.name ? state.name : {};
    },
  },
  actions: {
    fetchCompany({
      commit,
      dispatch
    }) {
      return new Promise((resolve, reject) => {
        commit('SET_REFRESHING_TRUE', 'company')
        commit('SET_ERROR_FALSE', 'company')
        getCompany()
          .then((company) => {
            commit('SET_INITIALIZED_TRUE', 'company')
            commit('SET_REFRESHING_FALSE', 'company')
            commit('SET_COMPANY', company)
            resolve()
          })
          .catch((err) => {
            commit('SET_REFRESHING_FALSE', 'company')
            commit('SET_ERROR_TRUE', 'company')
            reject(err)
            dispatch('auth/logOut', null, { root: true })
          })
      })
    },
    fetchPopups({ commit }) {
      return new Promise((resolve, reject) => {
        commit('SET_REFRESHING_TRUE', 'popups')
        commit('SET_ERROR_FALSE', 'popups')
        getCompanyPopups(0, 20)
          .then((popups) => {
            commit('SET_INITIALIZED_TRUE', 'popups')
            commit('SET_REFRESHING_FALSE', 'popups')
            commit('SET_POPUPS', popups)
            resolve()
          })
          .catch((err) => {
            commit('SET_REFRESHING_FALSE', 'popups')
            commit('SET_ERROR_TRUE', 'popups')
            reject(err)
          })
      })
    },
    fetchBonusPointsConfig({ commit }) {
      return new Promise((resolve, reject) => {
        commit('SET_REFRESHING_TRUE', 'bonusPoints')
        commit('SET_ERROR_FALSE', 'bonusPoints')
        getCompanyBonusPointsConfig()
          .then((config) => {
            commit('SET_INITIALIZED_TRUE', 'bonusPoints')
            commit('SET_REFRESHING_FALSE', 'bonusPoints')
            commit('SET_BONUS_POINTS_CONFIG', config)
            resolve()
          })
          .catch((err) => {
            commit('SET_REFRESHING_FALSE', 'bonusPoints')
            commit('SET_ERROR_TRUE', 'bonusPoints')
            reject(err)
          })
      })
    },
  },
  mutations: {
    SET_INITIALIZED_TRUE: (state, dataName) => {
      state.status[dataName].refreshing = true
    },
    SET_REFRESHING_TRUE: (state, dataName) => {
      state.status[dataName].refreshing = true
    },
    SET_REFRESHING_FALSE: (state, dataName) => {
      state.status[dataName].refreshing = false
    },
    SET_ERROR_TRUE: (state, dataName) => {
      state.status[dataName].error = true
    },
    SET_ERROR_FALSE: (state, dataName) => {
      state.status[dataName].error = false
    },
    SET_COMPANY: (state, payload) => {
      state.name = payload.name
      state.loginCopyHtml = payload.loginCopyHtml
      state.customLoginId = payload.customLoginId
      state.logoUrl = payload.logoUrl
      state.bannerUrl = payload.bannerUrl
      state.homepageMessageHtml = payload.homepageMessageHtml
      state.blogHeading = payload.blogHeading
      state.blogUrl = payload.blogUrl
      state.programNameHtml = payload.programNameHtml
      state.programDescriptionHtml = payload.programDescriptionHtml
      state.requireCredentialsForCheckout = payload.requireCredentialsForCheckout
      state.allowTaxPaymentWithPoints = payload.allowTaxPaymentWithPoints
      state.grossUpTaxes = payload.grossUpTaxes
      state.stripeCustomerId = payload.stripeCustomerId
      state.ratio = payload.ratio
      state.unallocDeposit = payload.unallocDeposit
      state.minpointvalue = payload.minpointvalue
      state.maxpointvalue = payload.maxpointvalue
    },
    SET_POPUPS: (state, payload) => {
      state.popups = payload
    },
    SET_BONUS_POINTS_CONFIG: (state, payload) => {
      state.bonusPointsIsEnabled = payload.isEnabled
      state.bonusPointsMenuItem = payload.menuItem
      state.bonusPointsPageTitle = payload.pageTitle
      state.bonusPointsPageMessage = payload.pageMessage
      state.bonusPointsPointsAlias = payload.pointsAlias
      state.bonusPointsIconClass = payload.iconClass
    },
  },
}

export default company
